import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import {PopupType} from "../popups/popupType";
import {Application} from "../application";
import * as ko from "knockout";

export class OpenEstimatesPopupCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.OpenEstimatesPopup;
    canExecute = ko.computed(() => {
        return true;
    });
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });
    execute<T>(context?: T): JQueryPromise<any> {

        if (!this.canExecute())
            return $.Deferred().reject().promise();

        return this.app.popupsManager.show(PopupType.estimates, false);
    }

    name = "Open estimate";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/openEstimatesPopupCommand.ts